module.exports = __webpack_public_path__ + "img/P5.e685932a.png";